import React, {Component} from "react";
import MocksConfigService from "../../service/MocksConfigService";
import {Link} from "react-router";
import CoreService from "../../service/CoreService";

class MockDetailPanel extends Component {
    constructor() {
        super();

        this.state = {
            mockUrl: '',
            specUrl: '',
        };

        this.showGenericPanel = this.showGenericPanel.bind(this);
        this.fetchMockUrl = this.fetchMockUrl.bind(this);
        this.buildRefreshButton = this.buildRefreshButton.bind(this);
        this.pokeMocks = this.pokeMocks.bind(this);
    }

    fetchMockUrl() {
        MocksConfigService.fetchMockEndpoints(this.props.mockId, (mockEndpoints) => {
            this.setState({
                mockUrl: mockEndpoints.baseUrl,
                specUrl: mockEndpoints.specUrl
            })
        });
    }

    pokeMocks() {
        MocksConfigService.pokeMocks(this.props.mockId, () => {
            CoreService.showPassiveInfo('Your mocks are restarting now. It may take a few minutes before they are ready.');
        });
    }

    /**
     * @param parameters {Object}
     * @param parameters.bodyText {String}
     * @param parameters.classSuffix {String} e.g. 'warning', 'info'
     * @param parameters.showFooterText {boolean}
     * @param parameters.showRefreshButton {boolean}
     * @param parameters.icon {String} e.g. 'circular-graph'
     */
    showGenericPanel(parameters) {
        let {titleText, bodyText, classSuffix, showFooterText, showRefreshButton, icon} = parameters;
        return (
            <div className={`alert alert-${classSuffix}`}>
                <h4>
                    <strong>{titleText}</strong>
                    {showRefreshButton && this.buildRefreshButton()}
                </h4>
                <div>
                    {icon && <i className={`icon icon-${icon} m-r-xs`}/>}
                    <span>{bodyText}</span>
                </div>
                {showFooterText &&
                <div className="small m-t-sm m-b-0"><i className="icon icon-info-with-circle"/> <strong>Note:</strong> After uploading files, your mocks may
                    take a few minutes before they are ready.
                </div>}
            </div>
        );
    }

    buildRefreshButton() {
        const self = this;
        return (
            <button type="button" className="btn btn-xs btn-default btn-borderless pull-right"
                    onClick={self.props.onRefresh}><i className="icon icon-cycle m-r-xs"/>Refresh status
            </button>
        );
    }

    componentDidMount() {
        this.fetchMockUrl();
    }

    render() {
        switch (this.props.status.status) {
            case 'LOADING':
                return this.showGenericPanel(
                    {
                        titleText: 'Mock endpoint',
                        bodyText: 'Loading mock status',
                        classSuffix: 'default',
                        showFooterText: false,
                        showRefreshButton: false,
                        icon: 'circular-graph'
                    }
                );

            case 'DRAFT':
                return this.showGenericPanel(
                    {
                        titleText: 'Draft mock',
                        bodyText: 'Your mock is in draft mode. Upload an OpenAPI specification to start your mock.',
                        classSuffix: 'warning',
                        showFooterText: false,
                        showRefreshButton: false
                    }
                );

            case 'UPDATING':
                return this.showGenericPanel(
                    {
                        titleText: 'Mock updating',
                        bodyText: 'Your updates are being applied to your mock.',
                        classSuffix: 'warning',
                        showFooterText: true,
                        showRefreshButton: true,
                        icon: 'circular-graph'
                    }
                );

            case 'ACTIVE':
                return (
                    <div className="alert alert-info">
                        <h4>
                            <strong>Mocks ready</strong>
                            {this.buildRefreshButton()}
                        </h4>
                        <div>
                            Access your mock at the following URL:
                        </div>
                        <div className="form-group m-t-sm">
                            <div className="well well-sm mock-endpoint">{this.state.mockUrl}</div>
                        </div>
                        <div className="form-group">
                            <a href={`${this.state.specUrl}`} target="_blank"
                               disabled={this.state.specUrl.length > 0 ? '' : 'disabled'}
                               className="btn btn-primary" type="button"><span
                                className="hidden-xs"><i className="icon icon-forward"/> View mock specification</span> <span
                                className="visible-xs"><i className="icon icon-forward"/> View specs</span>
                            </a>
                        </div>
                        <div className="small m-t-sm m-b-0 m-l-xs">
                            <i className="icon icon-info-with-circle"/> <strong>Note:</strong> After uploading files, your mock may take a few
                            minutes before it's ready to serve traffic.
                        </div>
                    </div>
                );

            case 'INACTIVE':
                return this.showGenericPanel(
                    {
                        titleText: 'Mock inactive',
                        bodyText: 'Your mock is not running. Upload an OpenAPI specification to start your mock.',
                        classSuffix: 'warning',
                        showFooterText: true,
                        showRefreshButton: true
                    }
                );

            case 'FAILED':
                return (
                    <div className="alert alert-danger">
                        <h4>
                            <strong>Mock error</strong>
                            {this.buildRefreshButton()}
                        </h4>
                        <div>
                            <span>Your mock failed during startup. Often this is due to invalid or incorrect configuration. Please upload a valid OpenAPI file and try again.</span>
                        </div>
                        <div className="m-t-sm">
                            <Link to="/logs" className="btn btn-default">View logs</Link>
                        </div>
                    </div>
                );

            case 'RETIRED':
                return (
                    <div className="alert alert-warning">
                        <h4>
                            <strong>Mock retired</strong>
                            {this.buildRefreshButton()}
                        </h4>
                        <div>
                            <span>
                                Mocks are retired when not in use on the <Link to="/subscription">free subscription plan</Link>.
                                Please upgrade your plan or restart your mock.
                            </span>
                        </div>
                        <div className="m-t-sm">
                            <button type="button" className="btn btn-default"
                                    onClick={this.pokeMocks}><i className="icon icon-cw"/> Restart mock
                            </button>
                            <Link to="/subscription" className="btn btn-primary m-l-xs"><i className="icon icon-price-ribbon" /> Upgrade Plan</Link>
                        </div>
                        <div className="small m-t-sm m-b-0 m-l-xs">
                            <i className="icon icon-info-with-circle"/> <strong>Note:</strong> After restarting, your mock may take a few
                            minutes before it's ready to serve traffic.
                        </div>
                    </div>
                );

            default:
                return this.showGenericPanel(
                    {
                        titleText: 'Mock status unknown',
                        bodyText: 'The status of your mock is unknown. If this persists, please contact support.',
                        classSuffix: 'warning',
                        showFooterText: false,
                        showRefreshButton: true
                    }
                );
        }
    }
}

MockDetailPanel.propTypes = {
    mockId: React.PropTypes.string.isRequired,
    status: React.PropTypes.object.isRequired,
    onRefresh: React.PropTypes.func.isRequired
};

export default MockDetailPanel;



// WEBPACK FOOTER //
// ./src/modules/views/mocks/MockDetailPanel.js